var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-b933ss",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 20 21",
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14.7852C17.5523 14.7852 18 15.2329 18 15.7852C18 16.3374 17.5523 16.7852 17 16.7852H3C2.44772 16.7852 2 16.3374 2 15.7852C2 15.2329 2.44772 14.7852 3 14.7852H17ZM17 9.78516C17.5523 9.78516 18 10.2329 18 10.7852C18 11.3374 17.5523 11.7852 17 11.7852H3C2.44772 11.7852 2 11.3374 2 10.7852C2 10.2329 2.44772 9.78516 3 9.78516H17ZM17 4.78516C17.5523 4.78516 18 5.23287 18 5.78516C18 6.33744 17.5523 6.78516 17 6.78516H3C2.44772 6.78516 2 6.33744 2 5.78516C2 5.23287 2.44772 4.78516 3 4.78516H17Z",
    fill: "#3B3B3B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapse);
export default __webpack_public_path__ + "static/media/icon_collapse.86d4259ea3d17acd53195cd387ac31d6.svg";
export { ForwardRef as ReactComponent };